import styled from "styled-components";
import {
  REGISTRATION_AMBER,
  REGISTRATION_FONT_BODY,
  REGISTRATION_FONT_DISPLAY,
} from "./registrationTheme";

export const RegistrationNavbarLogo = styled.img`
  display: block;
  height: 30px;
  max-height: 30px;
  width: auto;
  max-width: 100px;
  object-fit: contain;
  flex-shrink: 0;

  @media (max-width: 767px) {
    height: 20px;
    max-height: 20px;
    max-width: 44px;
  }
`;

export const RegistrationSetupNavbarRoot = styled.header`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  background: ${REGISTRATION_AMBER};
  border-bottom: 1px solid rgba(30, 42, 53, 0.08);
  box-sizing: border-box;
  z-index: 10;
`;

export const RegistrationLayoutRoot = styled.div`
  background: #eef1f5;

  .registration-layout__navbar-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    gap: 12px;
    min-height: 56px;
    padding: 10px clamp(12px, 1.5vw + 6px, 24px);
    padding-top: max(10px, env(safe-area-inset-top, 0px));
    box-sizing: border-box;
  }

  .registration-layout__navbar-left {
    display: flex;
    align-items: center;
    min-width: 0;
    justify-self: start;
  }

  .registration-layout__navbar-step {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  }

  .registration-layout__navbar-back-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #2d3f52;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-family: ${REGISTRATION_FONT_BODY};

    &:hover {
      opacity: 0.85;
    }
  }

  .registration-layout__navbar-step-label {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: #ffffff;
    font-family: ${REGISTRATION_FONT_BODY};
    white-space: nowrap;
  }

  .registration-layout__navbar-center {
    justify-self: center;
    text-align: center;
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-size: 15px;
    font-weight: 500;
    color: #2d3f52;
    line-height: 1.2;
    padding: 0 8px;
    max-width: min(320px, 42vw);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .registration-layout__navbar-center--welcome {
    color: #1e2a35;
    max-width: min(360px, 56vw);
  }

  .registration-layout__navbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: clamp(8px, 1.5vw, 14px);
    flex-shrink: 0;
    justify-self: end;
    min-width: 0;

    .language-selector--light .language-selector__trigger {
      font-size: 12px !important;
      padding: 4px 8px !important;
      width: auto !important;
      min-width: 0;
    }

    .language-selector--light .language-selector__menu {
      font-size: 12px !important;
    }

    .language-selector--light svg {
      width: 12px !important;
      height: 12px !important;
    }
  }

  .registration-layout__navbar-progress {
    width: 100%;
    height: 3px;
    flex-shrink: 0;
    background: transparent;
    overflow: hidden;
  }

  .registration-layout__navbar-progress-fill {
    height: 100%;
    background: #afd135;
    border-radius: 0 999px 999px 0;
    transition: width 0.4s ease;
  }

  @media (max-width: 767px) {
    .registration-layout__navbar-row {
      gap: 8px;
      min-height: 52px;
      padding: 8px 10px;
      padding-top: max(8px, env(safe-area-inset-top, 0px));
    }

    .registration-layout__navbar-step {
      gap: 12px;
    }

    .registration-layout__navbar-back-btn {
      font-size: 16px;
    }

    .registration-layout__navbar-step-label {
      font-size: 11px;
    }

    .registration-layout__navbar-center {
      font-size: 15px;
      max-width: min(220px, 40vw);
    }

    .registration-layout__navbar-center--welcome {
      max-width: min(260px, 52vw);
    }

    .registration-layout__navbar-right {
      gap: 5px;

      .language-selector--light .language-selector__trigger {
        font-size: 11px !important;
        padding: 3px 6px !important;
      }

      .language-selector--light .language-selector__menu {
        font-size: 11px !important;
      }

      .language-selector--light svg {
        width: 11px !important;
        height: 11px !important;
      }
    }
  }

  .registration-layout__main {
    min-height: 0;
    background: #eef1f5;
  }

  .registration-layout__main > * {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;
